import { DesktopOutlined, SettingOutlined, TeamOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Dropdown, Grid, type MenuProps } from 'antd';
import type { FC } from 'react';
import { useAuth } from 'react-oidc-context';
import { Link, useLocation } from 'react-router';
import { hasSomeRole, Role } from '../utils/user.ts';

const items: MenuProps['items'] = [
  {
    key: '/admin/benutzer',
    label: <Link to="/admin/benutzer">Benutzer</Link>,
    icon: <UserOutlined />,
  },
  {
    key: '/admin/accounts',
    label: <Link to="/admin/accounts">Accounts</Link>,
    icon: <TeamOutlined />,
  },
  {
    key: '/admin/themes',
    label: <Link to="/admin/themes">Themes</Link>,
    icon: <DesktopOutlined />,
  },
];

export const TopMenu: FC = () => {
  const location = useLocation();
  const auth = useAuth();
  const screens = Grid.useBreakpoint();

  if (!hasSomeRole([Role.ROLE_BEF_MEDCOM], auth.user)) {
    return null;
  }

  return (
    <Dropdown menu={{ items: items, selectable: true, selectedKeys: [location.pathname] }}>
      <Button icon={<SettingOutlined />} onClick={e => e.preventDefault()}>
        {screens.lg || screens.xl || screens.xxl ? 'Admin' : null}
      </Button>
    </Dropdown>
  );
};
